import { useTranslation } from "react-i18next";

import { ActionKind } from "../../types/Action";
import { Button } from "../Button";
import { Dialog } from "../Dialog";
import {
    RootStateKind,
    useOneOfRootStates,
    WelcomeSubStateKind
} from "../state/StateProvider";
import { questionMark } from "../svg";

export const OperatorModeDialog = () => {
    const {
        state: { subState },
        dispatch
    } = useOneOfRootStates(RootStateKind.OutOfOrder, RootStateKind.Welcome);
    const isDialogOpen =
        subState.kind === WelcomeSubStateKind.OperatorVerification;

    return (
        <>
            {isDialogOpen && <DialogContent />}
            <Button
                variant="secondary"
                className="z-10"
                onClick={() => {
                    dispatch({
                        kind: ActionKind.ShowOperatorBadgeVerification
                    });
                }}
                data-testid="operator-mode-button"
            >
                <div className="flex h-full items-center">{questionMark}</div>
            </Button>
        </>
    );
};

const DialogContent = () => {
    const { t } = useTranslation();
    const { dispatch } = useOneOfRootStates(
        RootStateKind.OutOfOrder,
        RootStateKind.Welcome
    );

    const handleCloseDialog = () => {
        dispatch({ kind: ActionKind.HideOperatorBadgeVerification });
    };

    return (
        <Dialog
            title={t("operatorModeDialog.title")}
            onBackgroundClick={handleCloseDialog}
            secondaryButton={{
                action: handleCloseDialog,
                title: t("cancel")
            }}
        >
            <div className="text-center">
                {t("operatorModeDialog.description")}
            </div>
        </Dialog>
    );
};
